<template>
  <v-app light>
    <div style="width:100%;background-color:#f3f3f3;height:100%; position: relative">
      <div class="logo-header">
        <!-- <img class="administrator" src="https://www.bbz.com.br/wp-content/uploads/2014/03/logo_bbz.jpg" alt="">
        <img class="plus" src="https://lh3.googleusercontent.com/MjBg-tZSC0bzca-YbIa_IuR0-yHpXLfaINtdcEkF9ARE_xNArijKgt2ksQPYX6W-hA=w300" alt=""> -->
        <v-slide-x-transition mode="out-in" class="hotsite-body" v-if="logoProvider === ''">
          <div class="titulo-logo mb-4 float-l">
            <img src="../../assets/logo.png" alt=""> <h4>CondoPlaza</h4>
          </div>
        </v-slide-x-transition>

        <v-slide-x-transition mode="out-in" class="hotsite-body" v-else>
          <img :src="logoProvider" :key="logoProvider" alt="">
        </v-slide-x-transition>

        <v-progress-linear v-show="anyLoading" v-bind:indeterminate="true" height="2" class="progrees-line" color="red" background-color="white"></v-progress-linear>
      </div>

      <v-slide-x-transition mode="out-in" class="hotsite-body">
        <router-view></router-view>
      </v-slide-x-transition>
    </div>

    <v-snackbar
      :timeout="toastShow.time"
      :color = "toastShow.color"
      :top="true"
      :right="true"
      v-model="toastShow.visibility"
    >
     {{ toastShow.text }}
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      showFeedbackBtn: false
    }
  },

  computed: {
    toastShow () {
      return this.$store.getters.toastr
    },

    logoProvider () {
      return this.$store.getters.logoProvider
    },

    loadingLogo () {
      return this.$store.getters.loadingLogo
    },

    anyLoading () {
      return this.$store.getters.loadingLogo || this.$store.getters.loadingEmail || this.$store.getters.loadingOrderRequest || this.$store.getters.loadingCheckout
    }
  }
}
</script>

<style>
#app{
  background: #f3f3f3;
}
.info-hotsite{
  color: #999999;
  font-size: 16px;
}
.box-email{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
}
.btn-hotsite-gray{
  border-radius: 10px;
  color: #999999 !important;
  background-color: #e7e7e7 !important;
  text-transform: none;
  margin-top: 10px;
}
.btn-hotsite {
  border-radius: 10px;
  color: #fff !important;
  background-color: #009865 !important;
}
.logo-header{
    position: relative;
    width: 100%;
    text-align: center;
    padding: 20px;
    min-height: 145.63px;
    background-color: #fff;
}
.logo-header img, .administrator{
  max-width: 200px;
  max-height: 100px;
}
.plus{
  width: 20px;
  position: relative;
  top: -50px;

}
.main-body{
  height: 100%;
  background-color: #f3f3f3;
}
.hotsite-body{
  background-color: #f3f3f3;
  padding-top: 50px;
}
.body{
  background: red;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
.box-email{
  background: #fff;
  width: 320px;
  margin: auto;
  padding: 20px;
  margin-top: 20px;
  border-radius: 20px;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.progrees-line{
  position: absolute;
  bottom:0;
  margin: 0;
  left: 0;
}
.titulo-logo{
  width: 300px;
  margin: auto;
}
.titulo-logo h4 {
  width: calc(100% - 80px);
  color: #a2a2a2;
  float: left;
  position: relative;
  top: 11px;
  font-size: 39px;
  left: 2px;
}
.titulo-logo img {
  width: 80px;
  height: 80px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// index.vue?9ceb0638